import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countParties, loadParties} from '../actions/parties';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Parties from '../components/party/Parties';
import {Acl, breadcrumbs} from "../utils";

class PartiesPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentDidMount() {
		this.props.loadGeneralEnum('partyAccounts', {})
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, eventId = null, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadParties(filter);
		this.props.countParties(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Subjekty'}])}
					</Col>
					<Col xs={4}>
						{Acl.isAllowed(session, Acl.right.PARTY_NEW) &&
						<Link to={{pathname: "/parties/new"}} className="btn btn-success pull-right"><span className="fa fa-plus"/> Nový</Link>}
					</Col>
				</Row>
				<Parties {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

PartiesPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadParties: PropTypes.func.isRequired,
	countParties: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {parties},
		enums,
		session
	} = state;

	const page = parties[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadParties,
	countParties,
	showMessage,
	resetPage,
	showModal
})(PartiesPage)
